<template>
  <footer class="footer" :class="{ 'fullscreen-section': isMobile, 'acc-expanded': accExpanded }" :style="isMobile ? {} : { minHeight: footerHeight + 'px' }">
    <!-- 1920 设计稿内容层，按宽度等比缩放 -->
    <div class="footer-inner" :style="{ transform: footerTransform }">
    <div class="footer-nav">
      <div class="footer-nav-item">
        <div class="logo-wrap">
          <img src="../assets/images/product/logo@2x.png" alt="logo" class="footer-logo" />
          <h4 v-if="$i18n.locale !== 'en'">{{ $t('footer.company') }}</h4>
        </div>
        <!-- 联系方式（复用 about 文案） -->
        <div class="footer-contact">
          <div class="footer-contact-block">
            <h4>{{ $t('about.afterSalesTitle') }}</h4>
            <p>{{ $t('about.afterSalesEmail') }}{{ $t('about.afterSalesEmailValue') }}</p>
            <p>{{ $t('about.afterSalesPhone') }}{{ $t('about.afterSalesPhoneValue') }}</p>
          </div>
          <div class="footer-contact-block">
            <h4>{{ $t('about.businessTitle') }}</h4>
            <p>{{ $t('about.businessEmail') }}{{ $t('about.businessEmailValue') }}</p>
            <p>{{ $t('about.businessPhone') }}{{ $t('about.businessPhoneValue') }}</p>
          </div>
        </div>
      </div>
      <div class="footer-nav-item nav-acc" :class="{ open: accOpen.home }">
        <h4 class="acc-header" @click="toggleAcc('home')">{{ $t('footer.home') }}<i class="acc-arrow"></i></h4>
        <div class="sub-menu" ref="subMenu-home" :class="{ 'is-open': accOpen.home }">
          <!-- 可孚孚探 -->
          <a href="#" @click.prevent="goHomeTop">{{ $t('footer.homeSub') }}</a>
        </div>
      </div>
      <div class="footer-nav-item nav-acc" :class="{ open: accOpen.product }">
        <h4 class="acc-header" @click="toggleAcc('product')">{{ $t('footer.product') }}<i class="acc-arrow"></i></h4>
        <div class="sub-menu" ref="subMenu-product" :class="{ 'is-open': accOpen.product }">
          <!-- 英文站隐藏线上商城 -->
          <a href="#" @click.prevent="goProduct()">{{ $t('footer.productSub1') }}</a>
          <a v-if="$i18n.locale !== 'en'" href="#" @click.prevent="goProduct('shop')">{{ $t('footer.productSub2') }}</a>
        </div>
      </div>
      <div class="footer-nav-item nav-acc" :class="{ open: accOpen.service }">
        <h4 class="acc-header" @click="toggleAcc('service')">{{ $t('footer.service') }}<i class="acc-arrow"></i></h4>
        <div class="sub-menu" ref="subMenu-service" :class="{ 'is-open': accOpen.service }">
          <a href="#" @click.prevent="goService('hero')">{{ $t('footer.serviceSub1') }}</a>
          <a href="#" @click.prevent="goService('video')">{{ $t('footer.serviceSub2') }}</a>
          <a href="#" @click.prevent="goService('faq')">{{ $t('footer.serviceSub3') }}</a>
        </div>
      </div>
      <div class="footer-nav-item nav-acc" :class="{ open: accOpen.download }">
        <h4 class="acc-header" @click="toggleAcc('download')">{{ $t('footer.download') }}<i class="acc-arrow"></i></h4>
        <div class="sub-menu" ref="subMenu-download" :class="{ 'is-open': accOpen.download }">
          <a href="#" @click.prevent="goDownload">{{ $t('footer.downloadSub1') }}</a>
          <a href="#" @click.prevent="goDownload">{{ $t('footer.downloadSub2') }}</a>
          <a href="#" @click.prevent="goDownload">{{ $t('footer.downloadSub3') }}</a>
        </div>
      </div>
      <div class="footer-nav-item nav-acc" :class="{ open: accOpen.about }">
        <h4 class="acc-header" @click="toggleAcc('about')">{{ $t('footer.about') }}<i class="acc-arrow"></i></h4>
        <div class="sub-menu" ref="subMenu-about" :class="{ 'is-open': accOpen.about }">
          <a href="#" @click.prevent="goAbout('intro')">{{ $t('footer.aboutSub1') }}</a>
          <a href="#" @click.prevent="goAbout('feature')">{{ $t('about.devTitle') }}</a>
          <a href="#" @click.prevent="goAbout('contact')">{{ $t('footer.aboutSub2') }}</a>
        </div>
      </div>
    </div>
    <div class="copyright">
      {{ $t('footer.copyright') }}-<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener">{{ $t('footer.icp') }}</a> <a :href="$t('footer.privacyUrl')" target="_blank" rel="noopener">{{ $t('footer.privacy') }}</a>
    </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      // 页脚缩放比例
      footerScale: 1,
      baseZoom: 1,
      isMobile: window.innerWidth <= 1024,
      // 手风琴展开状态（仅移动端）
      accOpen: { home: false, product: false, service: false, download: false, about: false },
      // 收起动画进行中
      closing: false,
      closeTimer: null
    }
  },
  computed: {
    footerTransform() {
      return 'translate(-50%, -50%) scale(' + this.footerScale + ')'
    },
    footerHeight() {
      // 高度随缩放比例
      return Math.ceil(310 * this.footerScale)
    },
    // 有栏目展开或收起动画未结束
    accExpanded() {
      const open = this.accOpen
      return this.closing || Object.keys(open).some((k) => open[k])
    }
  },
  methods: {
    // 手风琴展开/收起（仅移动端，互斥）
    toggleAcc(key) {
      if (!this.isMobile) {
        return
      }
      const willOpen = !this.accOpen[key]
      // 取消进行中的收起收尾
      if (willOpen) {
        clearTimeout(this.closeTimer)
        this.closing = false
      }
      Object.keys(this.accOpen).forEach((k) => {
        this.accOpen[k] = false
      })
      this.accOpen[key] = willOpen
      // 收起动画结束后再锁回一屏高度
      if (!willOpen) {
        this.closing = true
        this.closeTimer = setTimeout(() => {
          this.closing = false
        }, 420)
      }
      // 等类名切换后量取真实高度
      this.$nextTick(() => {
        Object.keys(this.accOpen).forEach((k) => {
          this.setSubMenuHeight(k)
        })
      })
    },
    // 子菜单行内高度（桌面端交回 CSS）
    setSubMenuHeight(key) {
      const el = this.$refs['subMenu-' + key]
      if (!el) {
        return
      }
      if (!this.isMobile) {
        el.style.height = ''
        return
      }
      el.style.height = this.accOpen[key] ? el.scrollHeight + 'px' : '0px'
    },
    updateFooterScale() {
      // 仅按宽度等比缩放
      const fit = window.innerWidth / 1920
      // DPR 补偿，跟随浏览器缩放
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.footerScale = fit * zoom
      this.isMobile = window.innerWidth <= 1024
      // 回桌面端时清理收起定时器
      if (!this.isMobile) {
        clearTimeout(this.closeTimer)
        this.closing = false
      }
      // 重算展开项行内高度
      Object.keys(this.accOpen).forEach((k) => {
        this.setSubMenuHeight(k)
      })
    },
    // 回首页顶部
    goHomeTop() {
      if (this.$route.path === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      this.$router.push('/')
    },
    // 产品页内部滚动，或带 ?to= 跳转
    goProduct(anchor) {
      if (this.$route.path === '/product') {
        if (anchor) {
          const el = document.querySelector('.module-' + anchor)
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' })
          }
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
        return
      }
      this.$router.push(anchor ? '/product?to=' + anchor : '/product')
    },
    // 服务页内部滚动，或带 ?to= 跳转
    goService(anchor) {
      if (this.$route.path === '/service') {
        const el = document.querySelector('.module-' + anchor)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
        return
      }
      this.$router.push('/service?to=' + anchor)
    },
    goDownload() {
      if (this.$route.path === '/download') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      this.$router.push('/download')
    },
    // 关于页内部滚动，或带 ?to= 跳转
    goAbout(anchor) {
      if (this.$route.path === '/about') {
        const el = document.querySelector('.module-' + anchor)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
        return
      }
      this.$router.push('/about?to=' + anchor)
    }
  },
  mounted() {
    // 记录初始 DPR
    this.baseZoom = window.devicePixelRatio || 1
    this.updateFooterScale()
    window.addEventListener('resize', this.updateFooterScale)
    // 语言切换后重算展开子菜单高度
    this.$watch('$i18n.locale', () => {
      Object.keys(this.accOpen).forEach((k) => {
        if (!this.accOpen[k]) {
          return
        }
        const el = this.$refs['subMenu-' + k]
        if (!el) {
          return
        }
        el.style.transition = 'none'
        el.style.height = el.scrollHeight + 'px'
        void el.offsetHeight
        el.style.transition = ''
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateFooterScale)
    clearTimeout(this.closeTimer)
  }
}
</script>

<style scoped>
.footer {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #00ADBB;
}

/* 内容层 */
.footer-inner {
  position: absolute;
  top: 47%;
  left: 50%;
  width: 1920px;
  height: auto;
  min-height: 310px;
  padding: 30px 0 30px 0;
  overflow: visible;
  transform-origin: center center;
  background: #00ADBB;
}

/* 导航栏 */
.footer-nav {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 160px;
  margin: 0 auto;
  padding: 10px 60px 0 160px;
}

/* 英文列间距收窄，防止总宽超出 */
@media (min-width: 1025px) {
  :lang(en) .footer-nav {
    gap: 140px;
  }
}

/* 水平分隔线 */
.footer-nav::before {
  content: '';
  position: absolute;
  top: 60px;
  left: 88px;
  right: 88px;
  height: 1px;
  background: #FFFFFF;
}

/* 导航列 */
.footer-nav-item {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

/* logo 与公司名 */
.logo-wrap {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 28px;
}

/* logo 图片高度 */
.footer-logo {
  height: 40px;
  display: block;
}

/* 列标题 */
.footer-nav-item h4 {
  height: 28px;
  font-family: 'PingFang SC';
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin: 0 0 60px 0;
}

/* 第 2~6 列居中 */
@media (min-width: 1025px) {
  .footer-nav-item:not(:first-child) h4 {
    text-align: left;
  }

  .footer-nav-item:not(:first-child) .sub-menu a,
  .footer-nav-item:not(:first-child) .sub-menu span {
    text-align: left;
  }
}

/* 首列标题 */
.footer-nav-item:first-child h4 {
  margin: 0;
}

/* 联系方式 */
.footer-contact {
  position: static;
  margin-top: 36px;
}

/* 联系方式分组间距 */
.footer-contact-block + .footer-contact-block {
  margin-top: 16px;
}

.footer-nav-item .footer-contact-block h4 {
  height: auto;
  margin: 0 0 6px 0;
}

/* 联系方式邮箱/电话 */
.footer-contact-block p {
  font-family: 'PingFang SC';
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  margin: 0;
  white-space: nowrap;
}

.sub-menu a,
.sub-menu span {
  display: block;
  font-family: 'PingFang SC';
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 24px;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 悬停态 */
.sub-menu a:hover {
  color: #fff;
}

/* 手风琴箭头，仅移动端显示 */
.acc-arrow {
  display: none;
}

/* 版权信息栏 */
.copyright {
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  font-family: 'PingFang SC';
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  font-style: normal;
  text-transform: none;
}

.copyright a {
  color: #FFFFFF;
  text-decoration: none;
}

.copyright a:hover {
  text-decoration: underline;
}

/* 移动端 */
@media (max-width: 1024px) {
  /* 默认锁定一屏高度 */
  .footer {
    height: 100vh;
    height: var(--app-height, 100vh);
    flex-shrink: 0;

    scroll-snap-align: start !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  /* 展开态：随内容增高 */
  .footer.acc-expanded {
    height: auto;
    min-height: 100vh;
    min-height: var(--app-height, 100vh);
  }

  /* 内容层改为文档流 */
  .footer-inner {
    position: static;
    width: 100%;
    height: auto;
    min-height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10vh 5vw 4vh;
    transform: none !important;
  }

  /* 隐藏桌面端分隔线 */
  .footer-inner::before,
  .footer-nav::before {
    display: none;
  }

  /* 导航栏改为纵向 */
  .footer-nav {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    max-width: none;
    margin: 0;
    padding: 0;
    transform: none;
  }

  /* 栏目行 */
  .footer-nav-item,
  :lang(en) .footer-nav-item {
    order: 1;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    transform: none;
  }

  /* 联系方式列排到手风琴下方 */
  .footer-nav-item:first-child {
    order: 2;
    margin-top: 2vh;
  }

  /* 隐藏 logo */
  .logo-wrap,
  .footer-logo {
    display: none;
  }

  /* 手风琴行 */
  .nav-acc {
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  }

  .nav-acc .acc-header {
    height: auto;
    width: 100%;
    margin: 0;
    padding: 3.4vh 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 4.8vw;
    color: #FFFFFF;
    text-align: left;
    cursor: pointer;
  }

  /* 展开箭头 */
  .acc-arrow {
    display: inline-block;
    width: 2.6vw;
    height: 2.6vw;
    border-right: 0.7vw solid #FFFFFF;
    border-bottom: 0.7vw solid #FFFFFF;
    transform: rotate(45deg);
    transition: transform 0.4s ease;
  }

  .nav-acc.open .acc-arrow {
    transform: rotate(-135deg);
  }

  /* 子菜单高度过渡 */
  .sub-menu {
    height: 0;
    overflow: hidden;
    transition: height 0.4s ease;
    padding: 0 0 0 3vw;
  }

  /* 链接文字随高度过渡 */
  .sub-menu a,
  .sub-menu span {
    white-space: normal;
    margin-bottom: 1.6vh;
    font-size: 3.73vw;
    text-align: left;
    transform: translateY(0);
    transition: transform 0.4s ease;
  }

  /* 收起态 */
  .sub-menu:not(.is-open) a,
  .sub-menu:not(.is-open) span {
    transform: translateY(-100%);
  }

  .sub-menu a:last-child {
    margin-bottom: 2.4vh;
  }

  /* 联系方式纵向排列 */
  .footer-contact {
    position: static;
    transform: none;
    margin: 1vh 0 2vh 0;
    display: flex;
    flex-direction: column;
    gap: 0.6vh;
  }

  .footer-contact-block {
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .footer-contact-block:first-child {
    transform: none;
  }

  .footer-contact-block h4 {
    height: auto;
    margin: 0 0 0.8vh;
    font-size: 4vw;
    color: #FFFFFF;
    text-align: left;
  }

  .footer-contact-block p {
    font-size: 3.2vw;
    margin-bottom: 0.2vh;
  }

  /* 版权信息 */
  .copyright {
    position: static;
    margin-top: 0;
    padding-top: 0;
    font-size: 3.2vw;
    line-height: 1.6;
    text-align: center;
  }
}
</style>
